import React from "react";
import Grid from "@mui/material/Grid";

const DivisionCardCmp = (props: any) => {
  return (
    <>
      {/* {props.value.map((item: any, index: number, array: any) => { */}
      <div style={{ width: "98%", margin: "auto" }}>
        <div className="cardBorder borderCOlor mTop20">
          {props.value.length == 0 ? (
            <></>
          ) : (
            <Grid
            container
            className="row"
            spacing={2}
            style={{ alignItems: "center", width: "98%", margin: "auto" }}
          >
            <Grid item style={{ alignItems: "left", paddingTop: "20px" ,minWidth:'22vh'}}>
              <div>
                <div className="divisionCardCmp" style={{ lineHeight: '1.9',marginLeft:'-2vh' }}>
                  <div className="colorTitle textFont14 " style={{maxWidth:'50vh',marginRight:'-1vh'}}>
                    {props.titleCard}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              item
              style={{
                alignItems: "right",
                paddingTop: "20px",
                maxWidth: "20vh",
                minWidth: "10vh",
                marginRight:"2vh",
                
              }}
            >
              {props.value[0].cardImage ?
                <img
                  className="designCard divisionCardTitle"
                  src={`data:image/png;base64,${props.value[0].cardImage}`}
                  alt="Red dot"
                /> :
                <img
                  className="designCard divisionCardTitle"
                  src={`images/defaultImg.jpg`}
                  alt="طرح انتخابی"
                />
              }

            </Grid>
            <Grid item xs={12}  sm container style={{ textAlign: "right", paddingTop: "20px", lineHeight: '1.9' ,marginRight:'3vh'}}>
              <Grid style={{ textAlign: "right", fontSize: "14px" }}>
                <b> {props.value[0].title}</b>
                {props.value[0].isBySupplierCredit
                  ? <b style={{ textAlign: "right", color: '#EE9D01', fontSize: '14px' }}>&nbsp;
                    &nbsp;(تضمین از محل اعتبار تامین کننده &nbsp;&nbsp;|&nbsp;&nbsp;اعتبار باقیمانده: {props.value[0].supplierCredit.toLocaleString()}&nbsp;&nbsp;ریال)</b>
                  : ''
                }
                <br />
                <br />
              </Grid>
              <Grid style={{ textAlign: "right" }} xs={12}>
                <span
                  style={{
                    background: "#1D4A87",
                    borderRadius: "5px",
                    color: "white",
                  }}
                >
                  &nbsp; &nbsp;تامین کننده مالی: {props.value[0].financialSupplierTitle} &nbsp; &nbsp;
                </span>
                &nbsp;&nbsp; | &nbsp;&nbsp;
                <span>سقف قابل اعطا: </span>
                <span style={{ marginLeft: "10px", fontWeight: "bold" }}>
                  &nbsp; {props.value[0].maxAmount.toLocaleString("fa")} (ریال)
                </span>
                |<span style={{ marginRight: "10px" }}>سود تسهیلات:</span>
                <span style={{ fontWeight: "bold" }}>
                  &nbsp; {props.value[0].profitPercentage}%{" "}
                </span>
                |
                <span style={{ marginRight: "10px" }}>
                  مهلت استفاده از تسهیلات:
                </span>
                <span style={{ fontWeight: "bold" }}>
                  &nbsp;{props.value[0].expirationDate_Persian}
                </span>
              </Grid>
            </Grid>
          </Grid>
          )}
        </div>
      </div>
      {/* })} */}
    </>
  );
};

export default DivisionCardCmp;
